/**
 * A download size a visitor can read at a glance. The unit is not translated: the strings carry no keys
 * for one, and KB/MB/GB survive translation better than most of what does.
 */
export const formatBytes = (bytes?: number): string => {
	if (!bytes || !Number.isFinite(bytes) || bytes <= 0) return '0 MB'

	const megabytes = bytes / 1_000_000

	if (megabytes < 1) return `${Math.max(1, Math.round(bytes / 1000))} KB`
	if (megabytes < 10) return `${megabytes.toFixed(1)} MB`
	if (megabytes < 1000) return `${Math.round(megabytes)} MB`

	return `${(megabytes / 1000).toFixed(1)} GB`
}

/**
 * How far a run has got, as a whole percentage.
 *
 * Counted from the queue draining rather than from the advertised size, which is the native figure and
 * overstates — it counts video, which the web does not download, and three image variants where the web
 * fetches one. An advertised 300 MB that only fetches 40 therefore self-corrects instead of stalling at 13%.
 */
export const percentComplete = (progress?: { done: number; total: number }): number => {
	if (!progress?.total) return 0

	return Math.min(100, Math.round((progress.done / progress.total) * 100))
}
